module.exports = __webpack_public_path__ + "static/media/bannerBlackoutMelhorProposta.ccea985e.jpg";